import { BindAll } from 'lodash-decorators'
import { WeiXinAuth } from '@xt/client/mixins/login/weixin'

@BindAll()
export class ControllerYouZan {
  constructor() {}

  /**
   * 获取有赞登录回调url
   */
  public getAuthorizeUrl(redirectUrl: string) {
    const url = new URL('https://oauth.youzan.com/h5/authorize')

    const _redirectUrl = localStorage.getItem('@redirect')

    url.searchParams.set('clientId', '5550257210931e45e7')
    url.searchParams.set('state', WeiXinAuth.YouZan)
    url.searchParams.set('scope', 'auth_user')
    url.searchParams.set('bizType', 'c')
    url.searchParams.set('redirectUrl', _redirectUrl ? _redirectUrl : redirectUrl)

    return url.toString()
  }
}
